import React from 'react'
import './first-section.scss'
import Button from '../../atoms/button/button'
import { navigate } from 'gatsby'
import useMediaQuery from '../../../hooks/useMediaQuery'
import CharacterWrapper from './character-wrapper'
import PremiosWrapper, { PremiosBase } from './premios-wrapper'
import Logo from '../../atoms/logo/logo'
import TEXTOS from './text.lang'
import { LOCALE, LOCALE_AT, topNumber } from '@/constants/activity-constants'
import imgPriorityBackgroundImage from '../../../assets/images/home/home-top-bg.webp'
import { Helmet } from 'react-helmet'

function Info({
  isMobile,
  callToAction,
}: {
  isMobile: boolean
  callToAction: React.ReactNode
}) {
  if (LOCALE_AT.URUGUAY) {
    return (
      <div className=" info-wrapper --uy">
        <article
          role="contentinfo"
          className="f-first-section__premiosinfo flex --column "
        >
          <div className="important --uy">{TEXTOS.paragraph1}</div>
          <div className="f-first-section__premios-base-wrapper">
            <PremiosBase isMobile={isMobile} />
          </div>
          {isMobile && callToAction}
        </article>
      </div>
    )
  }
  return (
    <div className=" info-wrapper ">
      <article
        role="contentinfo"
        className="f-first-section__premiosinfo flex --column "
      >
        {TEXTOS.paragraph1}
        <div className="important">
          <p>
            Sé una de las <b className="--extra">{topNumber} ganadoras </b>
          </p>
        </div>
        <PremiosWrapper isMobile={isMobile} />
        {isMobile && callToAction}
      </article>
    </div>
  )
}
export default function FirstSection({ id = '' }) {
  const isMobile = useMediaQuery()

  const callToAction = (
    <Button
      title="jugemos"
      onClick={() => {
        navigate('/play')
      }}
      className="call-to-action fade-in"
      data={{ 'data-tag': '7A', 'data-href': '/play' }}
    >
      ¡A JUGAR!
    </Button>
  )
  return (
    <section
      id={id}
      className="f-first-section"
      aria-label="Descripcion principal de la actividad y premios"
    >
      <Helmet>
        <link
          rel="preload"
          as="image"
          fetchPriority="high"
          href={imgPriorityBackgroundImage}
        />
      </Helmet>
      <div className="f-first-section__wrapper ">
        <div className="flex media-wrapper">
          <CharacterWrapper isMobile={isMobile} />
        </div>

        <div className="flex --column --gap2rem logo-wrapper">
          <div className="logo">
            <Logo isMobile={isMobile} />
          </div>
          {!isMobile && callToAction}
        </div>
        <Info isMobile={isMobile} callToAction={callToAction} />
      </div>
    </section>
  )
}
